import React, { Component } from 'react';
import EmptyState from './EmptyState';
import { HTMLTrans } from '../Common/Translations';

export default class AccountInfo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const bodyHeader = <p>
            <HTMLTrans id="account.accountinfo_title1">You haven't placed any orders with us yet. Why don't we change that?</HTMLTrans>
            <br />
            <span className="ProximaNova-Bold"><HTMLTrans id="account.accountinfo_title2">Let's get started.</HTMLTrans></span>
        </p>;

        const data = {
            heading: <HTMLTrans id="account.accountinfo_data_heading">Hi there!</HTMLTrans>,
            body: {
                header: bodyHeader,
                description: <HTMLTrans id="account.accountinfo_data_body_description">See what you can create now or see our current awesome discounts"</HTMLTrans>
            },
            ctaButtons: [
                {type: 'primary', refresh: true, label: <HTMLTrans id="account.accountinfo_data_button_createnow">Create Now</HTMLTrans>, url: this.props.tRoute('/product') },
                {type: 'outline', refresh: true, label: <HTMLTrans id="account.accountinfo_data_button_seepromo">See Our Promo</HTMLTrans>, url: this.props.tRoute('/promotions') }
            ]
        }
        return  <EmptyState data={data}/>
    }
}



// WEBPACK FOOTER //
// ./src/Account/AccountInfo.js